export default __webpack_public_path__ + "static/media/Icon_Search.be6814cc.png";